import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPrintModule } from 'ngx-print';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { QRCodeComponent } from 'angularx-qrcode';
import { SharedModule } from '../shared.module';
import { AacknowledgementSlipComponent } from './acknowledgement-slip/aacknowledgement-slip.component';
import { IncomeTaxCertificateComponent } from './income-tax-certificate/income-tax-certificate.component';

const TAX_CERTIFICATE_COMPONENTS = [
  AacknowledgementSlipComponent,
  IncomeTaxCertificateComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ModalModule,
    BsDatepickerModule,
    NgxPrintModule,
    NgxUiLoaderModule,
    QRCodeComponent,
  ],
  declarations: TAX_CERTIFICATE_COMPONENTS,
  exports: TAX_CERTIFICATE_COMPONENTS,
})
export class TaxCertificatesModule { }
